import React from "react";
import { LucideIcon } from "lucide-react";

// Generic "not built yet" placeholder — reused across the new Convo Unify /
// Convo Track sidebars for nav items that only exist as a label in the
// design for now, so each new sidebar item has somewhere to land instead of
// a blank/broken route.
const ComingSoonPage: React.FC<{ icon: LucideIcon; title: string; description?: string }> = ({
  icon: Icon,
  title,
  description,
}) => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-950 p-4 sm:p-6">
    <div className="flex flex-col items-center justify-center text-center py-24 sm:py-32">
      <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-blue-50 dark:bg-blue-500/15 mb-4">
        <Icon className="w-6 h-6 text-blue-600 dark:text-blue-400" />
      </span>
      <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 dark:text-gray-100">{title}</h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 max-w-md">
        {description || "This is coming soon — nothing here yet."}
      </p>
    </div>
  </div>
);

export default ComingSoonPage;
